import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 枚举模块
 */

export const Enum = {
    getSiteEnum(parmas, expend) { // 站点枚举
        return send("GET", "/api/company/selectOption/site", parmas, expend);
    },
    getDeviceTypeEnum(parmas, expend) { // 设备类型枚举
        return send("GET", "/api/common/enum/table/find", parmas, expend);
    },
    getDeviceEnum(parmas, expend) { // 设备枚举
        return send("GET", "/api/company/selectOption/siteDevice", parmas, expend);
    },
    getRtuEnum(parmas, expend) { // rtu枚举
        return send("GET", "/api/company/selectOption/rtu", parmas, expend);
    },
    getWarnEnum(parmas, expend) { // 告警规则枚举
        return send("GET", "/api/common/enum/find/siteWarnRuleStatus", parmas, expend);
    },
    getCompanyGroupEnum(parmas, expend) { // 获取企业分组枚举
        return send("GET", "/api/park/enum/find/Group", parmas, expend);
    }
}